// Firestore index required:
// Collection: trips/{tripId}/snapshots (subcollection)
// Fields: takenAt DESC
// Create in Firebase console if queries fail with index error.

import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  query,
  where,
  orderBy,
  limit,
  serverTimestamp,
} from "firebase/firestore";

import { auth } from "../firebase";

function stripUndefined(obj) {
  return JSON.parse(JSON.stringify(obj));
}

export async function takeSnapshot(db, tripId, label, days, activities, showToast) {
  try {
    let daysDocs = days;
    if (!daysDocs || daysDocs.length === 0) {
      const snap = await getDocs(
        query(collection(db, "days"), where("ownerUid", "==", auth.currentUser.uid), where("tripId", "==", tripId), orderBy("order"))
      );
      daysDocs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    }

    let actsDocs = activities;
    if (!actsDocs || actsDocs.length === 0) {
      const snap = await getDocs(
        query(collection(db, "activities"), where("ownerUid", "==", auth.currentUser.uid), where("tripId", "==", tripId))
      );
      actsDocs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
    }

    const snapshotsRef = collection(db, "trips", tripId, "snapshots");
    await addDoc(snapshotsRef, {
      tripId,
      label,
      takenAt: serverTimestamp(),
      days: stripUndefined(daysDocs.map(d => ({ ...d }))),
      activities: stripUndefined(actsDocs.map(({ previousVersion: _prev, ...rest }) => rest)),
    });

    const q = query(
      collection(db, "trips", tripId, "snapshots"),
      orderBy("takenAt", "desc"),
      limit(51)
    );
    const snap = await getDocs(q);
    if (snap.size === 51) {
      await deleteDoc(snap.docs[snap.docs.length - 1].ref);
    }

    return true;
  } catch (err) {
    console.error("takeSnapshot failed:", err);
    showToast?.("Snapshot failed to save", "error");
    return false;
  }
}
